import React, { useState, useEffect, useRef } from 'react';
import { pb, auth, memoriesApi, CATEGORIES } from './pocketbaseClient';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #0A0A0A; --surface: #141414; --card: #1C1C1C; --border: #2A2A2A;
    --accent: #7F77DD; --accent2: #534AB7; --text: #EDEBE8; --muted: #777471;
    --danger: #D85A30;
  }
  body { background: var(--bg); color: var(--text); font-family: 'DM Sans', sans-serif; min-height: 100vh; }
  input, textarea, button, select { font-family: 'DM Sans', sans-serif; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: var(--border); border-radius: 4px; }
  .app { display: grid; grid-template-columns: 220px 1fr; height: 100vh; overflow: hidden; }
  .sidebar { background: var(--surface); border-right: 0.5px solid var(--border); display: flex; flex-direction: column; padding: 24px 0; }
  .logo { display: flex; align-items: center; gap: 10px; padding: 0 20px 24px; border-bottom: 0.5px solid var(--border); margin-bottom: 16px; }
  .logo-text { font-size: 17px; font-weight: 700; }
  .nav-item { display: flex; align-items: center; gap: 10px; padding: 9px 20px; cursor: pointer; font-size: 14px; color: var(--muted); transition: all 0.12s; }
  .nav-item:hover { color: var(--text); background: rgba(255,255,255,0.04); }
  .nav-item.active { color: var(--text); background: rgba(127,119,221,0.12); border-right: 2px solid var(--accent); }
  .main { overflow: auto; }
  .panel { max-width: 760px; margin: 0 auto; padding: 32px 24px; }
  .page-title { font-size: 26px; font-weight: 700; letter-spacing: -0.5px; margin-bottom: 24px; }
  .search-bar { position: relative; margin-bottom: 20px; }
  .search-bar input { width: 100%; background: var(--surface); border: 0.5px solid var(--border); border-radius: 10px; color: var(--text); padding: 10px 14px 10px 38px; font-size: 14px; outline: none; transition: border 0.15s; }
  .search-bar input:focus { border-color: var(--accent); }
  .search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--muted); }
  .cat-pills { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 20px; }
  .cat-pill { padding: 5px 13px; border-radius: 20px; border: 0.5px solid var(--border); font-size: 13px; color: var(--muted); cursor: pointer; background: transparent; transition: all 0.12s; }
  .cat-pill:hover { color: var(--text); }
  .cat-pill.active { color: #fff; border-color: transparent; }
  .memories-grid { display: grid; gap: 12px; }
  .memory-card { background: var(--card); border: 0.5px solid var(--border); border-radius: 12px; padding: 14px 16px; transition: border-color 0.15s; }
  .memory-card:hover { border-color: #444; }
  .memory-card.pinned { border-color: var(--accent); }
  .card-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
  .cat-badge { padding: 3px 9px; border-radius: 6px; font-size: 12px; font-weight: 600; }
  .card-actions { display: flex; gap: 10px; }
  .card-action { background: none; border: none; cursor: pointer; color: var(--muted); font-size: 15px; padding: 2px; transition: color 0.1s; }
  .card-action:hover { color: var(--text); }
  .card-title { font-size: 15px; font-weight: 600; margin-bottom: 4px; }
  .card-content { font-size: 14px; color: var(--muted); line-height: 1.55; }
  .card-date { font-size: 11px; color: var(--muted); opacity: 0.7; margin-top: 10px; }
  .add-btn { display: flex; align-items: center; gap: 8px; background: var(--accent); color: #fff; border: none; border-radius: 10px; padding: 10px 18px; font-size: 14px; font-weight: 600; cursor: pointer; margin-bottom: 20px; transition: opacity 0.15s; }
  .add-btn:hover { opacity: 0.85; }
  .top-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
  .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.7); display: flex; align-items: flex-end; justify-content: center; z-index: 100; }
  .modal { background: var(--surface); border: 0.5px solid var(--border); border-radius: 20px 20px 0 0; padding: 24px; width: 100%; max-width: 600px; }
  .modal-title { font-size: 18px; font-weight: 700; margin-bottom: 18px; }
  .form-input { width: 100%; background: var(--card); border: 0.5px solid var(--border); border-radius: 10px; color: var(--text); padding: 10px 14px; font-size: 14px; outline: none; margin-bottom: 12px; transition: border 0.15s; }
  .form-input:focus { border-color: var(--accent); }
  textarea.form-input { resize: vertical; min-height: 100px; line-height: 1.5; }
  .form-row { display: flex; gap: 10px; }
  .save-btn { background: var(--accent); color: #fff; border: none; border-radius: 10px; padding: 11px 22px; font-size: 14px; font-weight: 600; cursor: pointer; }
  .cancel-btn { background: transparent; color: var(--muted); border: 0.5px solid var(--border); border-radius: 10px; padding: 11px 22px; font-size: 14px; cursor: pointer; }
  .chat-messages { flex: 1; overflow-y: auto; padding: 24px; display: flex; flex-direction: column; gap: 16px; }
  .chat-msg { display: flex; gap: 12px; }
  .chat-avatar { width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }
  .chat-bubble { padding: 11px 15px; border-radius: 14px; font-size: 14px; line-height: 1.55; max-width: 75%; }
  .msg-ai .chat-bubble { background: var(--card); border-bottom-left-radius: 4px; }
  .msg-user .chat-bubble { background: var(--accent2); border-bottom-right-radius: 4px; }
  .chat-input-row { display: flex; gap: 10px; padding: 16px 24px; border-top: 0.5px solid var(--border); background: var(--surface); }
  .chat-input { flex: 1; background: var(--card); border: 0.5px solid var(--border); border-radius: 10px; color: var(--text); padding: 10px 14px; font-size: 14px; outline: none; }
  .chat-input:focus { border-color: var(--accent); }
  .chat-send { background: var(--accent); color: #fff; border: none; border-radius: 10px; width: 40px; cursor: pointer; font-size: 18px; }
  .stats-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 24px; }
  .stat-card { background: var(--card); border: 0.5px solid var(--border); border-radius: 12px; padding: 16px; }
  .stat-val { font-size: 28px; font-weight: 700; margin-bottom: 4px; }
  .stat-label { font-size: 12px; color: var(--muted); }
  .auth-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: var(--bg); }
  .auth-box { background: var(--surface); border: 0.5px solid var(--border); border-radius: 16px; padding: 32px; width: 100%; max-width: 380px; }
  .auth-title { font-size: 22px; font-weight: 700; margin-bottom: 4px; }
  .auth-sub { color: var(--muted); font-size: 14px; margin-bottom: 24px; }
  .auth-btn { width: 100%; background: var(--accent); color: #fff; border: none; border-radius: 10px; padding: 12px; font-size: 15px; font-weight: 600; cursor: pointer; }
  .auth-toggle { text-align: center; margin-top: 16px; font-size: 14px; color: var(--muted); }
  .auth-toggle span { color: var(--accent); cursor: pointer; }
  .error { color: var(--danger); font-size: 13px; margin-bottom: 10px; }
  .empty { text-align: center; padding: 64px 0; color: var(--muted); }
  .empty-icon { font-size: 40px; margin-bottom: 12px; }
  .loading { display: flex; align-items: center; justify-content: center; height: 200px; font-size: 13px; color: var(--muted); }
`;

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    document.title = '🧠 Second Brain';
    const { data } = auth.getUser();
    setUser(data.user);
    setLoading(false);
    const { data: sub } = auth.onAuthChange((_, session) => {
      setUser(session?.user ?? null);
    });
    return () => sub?.subscription?.unsubscribe();
  }, []);

  if (loading) return <div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0A0A0A',color:'#777' }}>🧠 Loading…</div>;
  if (!user) return <AuthScreen />;
  return <MainLayout user={user} />;
}

function AuthScreen() {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error: err } = mode === 'login'
      ? await auth.signIn(form.email, form.password)
      : await auth.signUp(form.email, form.password, form.name);
    if (err) setError(err.message);
    setLoading(false);
  };

  return (
    <div className="auth-wrap">
      <div className="auth-box">
        <div style={{ fontSize: 40, marginBottom: 12 }}>🧠</div>
        <div className="auth-title">Second Brain</div>
        <div className="auth-sub">Your AI-powered memory system</div>
        <form onSubmit={submit}>
          {mode === 'signup' && <input className="form-input" placeholder="Full name" value={form.name} onChange={e => setForm(p => ({...p, name: e.target.value}))} />}
          <input className="form-input" placeholder="Email" type="email" value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))} />
          <input className="form-input" placeholder="Password" type="password" value={form.password} onChange={e => setForm(p => ({...p, password: e.target.value}))} />
          {error && <div className="error">{error}</div>}
          <button className="auth-btn" type="submit" disabled={loading}>{loading ? '…' : mode === 'login' ? 'Sign In' : 'Create Account'}</button>
        </form>
        <div className="auth-toggle">
          {mode === 'login' ? <>No account? <span onClick={() => setMode('signup')}>Sign up</span></> : <>Have an account? <span onClick={() => setMode('login')}>Sign in</span></>}
        </div>
      </div>
    </div>
  );
}

function MainLayout({ user }) {
  const [tab, setTab] = useState('memories');
  const navItems = [
    { id: 'memories', label: 'Memories', emoji: '🧠' },
    { id: 'chat', label: 'AI Chat', emoji: '💬' },
    { id: 'stats', label: 'Stats', emoji: '📊' },
  ];
  return (
    <div className="app">
      <nav className="sidebar">
        <div className="logo"><span style={{fontSize:24}}>🧠</span><span className="logo-text">Second Brain</span></div>
        {navItems.map(n => (
          <div key={n.id} className={`nav-item ${tab === n.id ? 'active' : ''}`} onClick={() => setTab(n.id)}>
            <span>{n.emoji}</span> {n.label}
          </div>
        ))}
        <div style={{ marginTop: 'auto', padding: '0 20px' }}>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user.email}</div>
          <button onClick={() => auth.signOut()} style={{ background: 'none', border: '0.5px solid var(--border)', color: 'var(--muted)', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 13 }}>Sign out</button>
        </div>
      </nav>
      <main className="main">
        {tab === 'memories' && <MemoriesView user={user} />}
        {tab === 'chat' && <ChatView />}
        {tab === 'stats' && <StatsView />}
      </main>
    </div>
  );
}

function MemoriesView({ user }) {
  const [memories, setMemories] = useState([]);
  const [category, setCategory] = useState('all');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);

  const load = async () => {
    setLoading(true);
    const { data } = await memoriesApi.getAll({ category, search });
    setMemories(data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, [category, search]);

  useEffect(() => {
    const sub = memoriesApi.subscribe(user.id, load);
    return () => sub.unsubscribe();
  }, []);

  return (
    <div className="panel">
      <div className="top-row">
        <h1 className="page-title" style={{margin:0}}>Memories</h1>
        <button className="add-btn" onClick={() => setShowAdd(true)}>+ Add Memory</button>
      </div>
      <div className="search-bar">
        <span className="search-icon">🔍</span>
        <input placeholder="Search your memories…" value={search} onChange={e => setSearch(e.target.value)} />
      </div>
      <div className="cat-pills">
        {CATEGORIES.map(cat => (
          <button key={cat.id} className={`cat-pill ${category === cat.id ? 'active' : ''}`}
            style={category === cat.id ? { backgroundColor: cat.color } : {}}
            onClick={() => setCategory(cat.id)}>
            {cat.label}
          </button>
        ))}
      </div>
      {loading ? <div className="loading">Loading…</div> : (
        <div className="memories-grid">
          {memories.length === 0
            ? <div className="empty"><div className="empty-icon">🗒️</div><div>No memories yet. Add one!</div></div>
            : memories.map(m => <MemoryCard key={m.id} memory={m} onRefresh={load} />)
          }
        </div>
      )}
      {showAdd && <AddMemoryModal onClose={() => setShowAdd(false)} onSaved={load} />}
    </div>
  );
}

function MemoryCard({ memory: m, onRefresh }) {
  const color = CATEGORIES.find(c => c.id === m.category)?.color || '#888';
  return (
    <div className={`memory-card ${m.is_pinned ? 'pinned' : ''}`}>
      <div className="card-top">
        <span className="cat-badge" style={{ backgroundColor: color + '25', color }}>{m.category}</span>
        <div className="card-actions">
          <button className="card-action" onClick={async () => { await memoriesApi.togglePin(m.id, m.is_pinned); onRefresh(); }}>{m.is_pinned ? '📌' : '🔖'}</button>
          <button className="card-action" onClick={async () => { if (window.confirm('Delete this memory?')) { await memoriesApi.delete(m.id); onRefresh(); } }}>🗑️</button>
        </div>
      </div>
      {m.title && <div className="card-title">{m.title}</div>}
      <div className="card-content">{m.content}</div>
      <div className="card-date">{new Date(m.created).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</div>
    </div>
  );
}

function AddMemoryModal({ onClose, onSaved }) {
  const [form, setForm] = useState({ title: '', content: '', category: 'note' });
  const [loading, setLoading] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (!form.content.trim()) return;
    setLoading(true);
    await memoriesApi.create(form);
    setLoading(false);
    onSaved();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-title">Add Memory</div>
        <form onSubmit={save}>
          <input className="form-input" placeholder="Title (optional)" value={form.title} onChange={e => setForm(p => ({...p, title: e.target.value}))} />
          <textarea className="form-input" placeholder="What do you want to remember?" value={form.content} onChange={e => setForm(p => ({...p, content: e.target.value}))} required />
          <div className="cat-pills" style={{ marginBottom: 16 }}>
            {CATEGORIES.filter(c => c.id !== 'all').map(cat => (
              <button type="button" key={cat.id} className={`cat-pill ${form.category === cat.id ? 'active' : ''}`}
                style={form.category === cat.id ? { backgroundColor: cat.color } : {}}
                onClick={() => setForm(p => ({...p, category: cat.id}))}>
                {cat.label}
              </button>
            ))}
          </div>
          <div className="form-row">
            <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="save-btn" disabled={loading}>{loading ? 'Saving…' : 'Save Memory'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ChatView() {
  const [messages, setMessages] = useState([{ role: 'assistant', content: "Hi! I'm your Second Brain AI. Ask me anything or tell me something to remember." }]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const send = async () => {
    const text = input.trim();
    if (!text) return;
    setInput('');
    const next = [...messages, { role: 'user', content: text }];
    setMessages(next);
    setLoading(true);
    try {
      const res = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'claude-sonnet-4-20250514',
          max_tokens: 800,
          system: 'You are the user\'s Second Brain — a personal AI memory assistant. Be concise, warm, and helpful.',
          messages: next.map(m => ({ role: m.role === 'assistant' ? 'assistant' : 'user', content: m.content })),
        }),
      });
      const data = await res.json();
      setMessages(prev => [...prev, { role: 'assistant', content: data.content?.[0]?.text || 'Error.' }]);
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: 'Connection error.' }]);
    }
    setLoading(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div style={{ padding: '24px 24px 16px', borderBottom: '0.5px solid var(--border)' }}>
        <h1 className="page-title" style={{ margin: 0 }}>AI Chat</h1>
      </div>
      <div className="chat-messages">
        {messages.map((m, i) => (
          <div key={i} className={`chat-msg ${m.role === 'user' ? 'msg-user' : 'msg-ai'}`}>
            <div className="chat-avatar" style={{ background: m.role === 'user' ? 'var(--accent2)' : 'var(--card)' }}>{m.role === 'user' ? '👤' : '🧠'}</div>
            <div className="chat-bubble">{m.content}</div>
          </div>
        ))}
        {loading && <div className="chat-msg msg-ai"><div className="chat-avatar" style={{background:'var(--card)'}}>🧠</div><div className="chat-bubble" style={{color:'var(--muted)'}}>Thinking…</div></div>}
        <div ref={bottomRef} />
      </div>
      <div className="chat-input-row">
        <input className="chat-input" placeholder="Ask your brain…" value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && send()} />
        <button className="chat-send" onClick={send}>↑</button>
      </div>
    </div>
  );
}

function StatsView() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    memoriesApi.getAll().then(({ data }) => {
      if (!data) return;
      const byCategory = {};
      data.forEach(m => { byCategory[m.category] = (byCategory[m.category] || 0) + 1; });
      setStats({ total: data.length, pinned: data.filter(m => m.is_pinned).length, byCategory });
    });
  }, []);

  if (!stats) return <div className="loading">Loading stats…</div>;

  return (
    <div className="panel">
      <h1 className="page-title">Stats</h1>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-val">{stats.total}</div><div className="stat-label">Total memories</div></div>
        <div className="stat-card"><div className="stat-val">{stats.pinned}</div><div className="stat-label">Pinned</div></div>
        <div className="stat-card"><div className="stat-val">{Object.keys(stats.byCategory).length}</div><div className="stat-label">Categories used</div></div>
      </div>
      <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>By category</h2>
      <div style={{ display: 'grid', gap: 8 }}>
        {Object.entries(stats.byCategory).map(([cat, count]) => {
          const color = CATEGORIES.find(c => c.id === cat)?.color || '#888';
          const pct = Math.round((count / stats.total) * 100);
          return (
            <div key={cat} style={{ background: 'var(--card)', borderRadius: 10, padding: '12px 16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                <span className="cat-badge" style={{ backgroundColor: color + '25', color }}>{cat}</span>
                <span style={{ fontSize: 13, color: 'var(--muted)' }}>{count} ({pct}%)</span>
              </div>
              <div style={{ background: 'var(--border)', borderRadius: 4, height: 4 }}>
                <div style={{ width: `${pct}%`, background: color, height: '100%', borderRadius: 4 }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
